/*
  OKA — Ask AI floating pill (see snippets/oka-ask-ai.liquid).

  Three jobs:
  1. Open / close / dismiss the panel.
  2. Keep every AI link's href in sync with the question textarea. Hrefs are
     rewritten on input (never at click time) because oka-analytics.liquid
     registers its click listener first — building the URL on click would let
     the analytics handler read a stale value.
  3. Keep the pill clear of the Shopify Forms "OKA MEMBERSHIP" teaser, a fixed
     element inside a shadow root at z-index 2147483647 in the bottom-left
     corner. Its height differs per breakpoint (measured 2026-08-27: visible card
     top ~91px above the viewport bottom on desktop, ~67px on mobile), so a
     static CSS offset either overlaps it or floats too high. We measure the card
     and lift the pill above it; when it is absent or dismissed the pill drops
     back to the CSS bottom.
*/
(function () {
  var root = document.getElementById('OkaAskAi');
  if (!root) return;

  var toggle = root.querySelector('.oka-ask-ai__toggle');
  var panel = document.getElementById('OkaAskAiPanel');
  var closeBtn = root.querySelector('.oka-ask-ai__close');
  var input = document.getElementById('OkaAskAiInput');
  var links = root.querySelectorAll('a[data-oka-ask-ai]');
  var chips = root.querySelectorAll('.oka-ask-ai__chip');
  var HIDE_KEY = 'oka_ask_ai_hidden';
  var ANCHOR = 'About OKA Kickboxing Club in Irvine, CA (okakickboxing.com): ';
  var MAX = 300;

  try {
    if (sessionStorage.getItem(HIDE_KEY) === '1') {
      root.style.display = 'none';
      return;
    }
  } catch (e) {}

  /* ---------- question -> hrefs ---------- */
  var defaultQuestion = input ? input.value : '';
  var source = 'default';

  function buildQuestion() {
    var text = (input ? input.value : '').trim();
    if (!text) text = defaultQuestion;
    // Keep the AI grounded even if the visitor replaces the whole thing with
    // something like "parking?" — the gym name and site have to survive.
    if (text.toLowerCase().indexOf('okakickboxing.com') === -1) text = ANCHOR + text;
    return text.slice(0, MAX + ANCHOR.length);
  }

  function syncLinks() {
    var q = encodeURIComponent(buildQuestion());
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', links[i].getAttribute('data-oka-url') + q);
      links[i].setAttribute('data-oka-prompt-source', source);
    }
  }

  if (input) {
    input.addEventListener('input', function () {
      source = input.value.trim() === defaultQuestion.trim() ? 'default' : 'custom';
      syncLinks();
    });
  }

  for (var c = 0; c < chips.length; c++) {
    chips[c].addEventListener('click', function (e) {
      if (!input) return;
      input.value = e.currentTarget.getAttribute('data-oka-ask-q') || '';
      source = 'chip';
      syncLinks();
      input.focus();
    });
  }

  syncLinks();

  /* ---------- panel ---------- */
  function setOpen(open) {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  toggle.addEventListener('click', function () {
    setOpen(panel.hidden);
  });

  closeBtn.addEventListener('click', function () {
    root.style.display = 'none';
    try { sessionStorage.setItem(HIDE_KEY, '1'); } catch (e) {}
  });

  document.addEventListener('click', function (e) {
    if (panel.hidden) return;
    if (!root.contains(e.target)) setOpen(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) {
      setOpen(false);
      toggle.focus();
    }
  });

  /* ---------- stay clear of the membership teaser ---------- */
  function findTeaser() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < hosts.length; i++) {
      var shadow = hosts[i].shadowRoot;
      if (!shadow) continue;
      var els = shadow.querySelectorAll('*');
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        var r = el.getBoundingClientRect();
        if (r.height < 20 || r.width < 50) continue;
        // bottom-left corner only
        if (r.left > window.innerWidth * 0.5) continue;
        if (r.bottom < window.innerHeight - 200) continue;
        if (window.innerHeight - r.top > 400) continue;
        var bg = window.getComputedStyle(el).backgroundColor;
        if (!bg || bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)') continue;
        return el;
      }
    }
    return null;
  }

  function reposition() {
    var teaser = findTeaser();
    if (!teaser) {
      root.style.bottom = '';
      return;
    }
    var r = teaser.getBoundingClientRect();
    root.style.bottom = Math.round(window.innerHeight - r.top) + 12 + 'px';
  }

  reposition();

  // The teaser is injected late and can be dismissed, so re-check for a while
  // and again on the events that change the layout.
  var checks = 0;
  var timer = setInterval(function () {
    reposition();
    if (++checks > 40) clearInterval(timer); // ~30s
  }, 750);

  window.addEventListener('resize', reposition);
  document.addEventListener('click', function () {
    setTimeout(reposition, 400);
  });
})();
